<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row">
      <div class="col-sm-12 px-0">
        {{$t('manage_users')}}
      </div>
    </div>
    <form id="linkUSerWithOrganisationForm" name="linkUSerWithOrganisationForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
      <div class="row">

        <div class="col-sm-12 px-0">
          <user-selector @event-change-member="onChange"></user-selector>
        </div>
        <div class="text-right col-sm-12 px-0 mt-1 text-right">
          <button type="submit" class="btn skin primary-button mt-1" @click="createOrganisationUser">{{$t('add_user')}}</button>
        </div>
      </div>
    </form>
    <div class="row">
      <basic-table ref="OrganisationUsersTable" enableedit="true" v-bind:responsive="true">
        <template slot="menu" scope="childDataScope">
          <a v-bind:href="'javascript:deleteOrganisationUser(' + childDataScope.row.Id + ')'" class="dropdown-item">{{$t('delete')}}</a>
        </template>
      </basic-table>
    </div>
  </div>
</template>

<script>
  import MemberSelector from '../user/user-selector.vue'

  import BasicTable from '../tables/basic-table.vue'
  let users = [];
  var buttontext = "";

  var teamMemberName = "";
  export default {
    name: "add-user-Organisation",
    components: {
      BasicTable,
      MemberSelector
    },
    props: {
      organisationid: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        teamMemberName,
        users: [],
      };
    },
    methods: {
      onChange(memberName) {
        this.teamMemberName = memberName;
      },
      async createOrganisationUser() {        
        if (!$('#linkUSerWithOrganisationForm').valid())
          return false;
        if (this.teamMemberName !== "") {
          var request = { id: this.organisationid, user: this.teamMemberName };

          try {
            var response = await this.$http.post(
              '/api/Organization/v1/AddOrganisationUser',
              request
            ).then(async response => {
              //vm.$root.$emit('refreshview');
              this.getOrganisationUsers(this.organisationid);
            });

          } catch (err) {
            alert(err);
          }
        }
      },
      async getOrganisationUsers(OrganisationtId) {
        try {
          this.users = [];
          this.$http.get('/api/Organization/Users/' + OrganisationtId).then(async response => {
            this.users = response.data;

            var headerdata = [
              { headername: "Organisation users", columnname: "name", css: "", datahide: "", enabled: true, databreakpoints: "" }
            ];
            var tabledata = this.users;
            this.$refs.OrganisationUsersTable.setData(headerdata, tabledata);
            this.$refs.OrganisationUsersTable.render();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async handleRefresh() {
        this.getOrganisationUsers(this.organisationid);
      }

    },
    watch: {
      organisationid: function (newVal, oldVal) {
        //alert('watch organisationid:' + newVal)
        if (newVal > 0) {
          //alert('getOrganisationUsers():' + newVal);
          this.getOrganisationUsers(newVal);
        }
      }
    },
    mounted() {
      _componentValidation('#linkUSerWithOrganisationForm');
      if (this.organisationid > 0) {
        this.getOrganisationUsers(this.organisationid);
      }
      this.buttontext = this.$t('add_user');
    }
  };


</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/organisation/add-user-organisation.vue